import React from 'react';
import { array } from 'prop-types';
import { stringToAnchor } from '../../../../../App/utils';

import './index.scss';

const ContentNav = ({ headings, isNumbered }) => {
    const ListTag = isNumbered ? 'ol' : 'ul';

    return (
        <nav className="content-navigation">
            <ListTag>
                {
                    headings.map((heading, idx) => (
                        <a key={idx} href={stringToAnchor(heading)}>
                            <li key={idx}>
                                {heading}
                            </li>
                        </a>
                    ))
                }
            </ListTag>
        </nav>
    );
};

ContentNav.propTypes = {
    headings: array
};

export default ContentNav;
